import React, { ReactElement } from 'react';
import { Button } from '@mui/material';
import { ButtonWrapper } from './ButtonStyles';

interface IButton {
    disableElevation?: boolean;
    startIcon?: ReactElement;
    endIcon?: ReactElement;
    fullWidth?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    onKeyPress?: () => void;
    variant?: 'text' | 'contained' | 'outlined';
    buttonName?: string;
    size?: 'small' | 'medium' | 'large';
    className?: string;
    type?: any;
    color?: any;
    sx?: any;
}
export const ButtonComponent = ({
    disableElevation = true,
    startIcon,
    endIcon,
    variant,
    buttonName,
    disabled,
    onClick,
    fullWidth,
    size,
    className,
    onKeyPress,
    type,
    sx,
    color,
}: IButton) => {
    return (
        <ButtonWrapper>
            <Button
                startIcon={startIcon}
                disableElevation={disableElevation}
                endIcon={endIcon}
                variant={variant}
                disabled={disabled}
                fullWidth={fullWidth}
                onClick={onClick}
                onKeyPress={onKeyPress}
                size={size}
                className={className}
                type={type || 'submit'}
                sx={sx}
                color={color}
            >
                {buttonName}
            </Button>
        </ButtonWrapper>
    );
};

ButtonComponent.defaultProps = {
    disableElevation: true,
    startIcon: undefined,
    endIcon: undefined,
    variant: 'contained',
    buttonName: '',
    disabled: false,
    onClick: undefined,
    fullWidth: false,
    size: 'medium',
    className: '',
    onKeyPress: undefined,
    type: 'submit',
};
